import { supabase } from '../supabaseClient';

/* Accès aux données « phases ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchPhases() {
  return supabase.from('phases').select('*').order('id');
}

export function closePhase(phaseId, today) {
  return supabase.from('phases').update({ date_fin: today }).eq('id', phaseId);
}

export function cancelPhase(phaseId, today) {
  return supabase.from('phases').update({ annulee_le: today }).eq('id', phaseId);
}

export function insertPhaseFromDeal(fact, jiraKey, m, ph, phId) {
  return supabase.from('phases').insert({
    id: phId,
    client_id: m.client_id,
    nom: ph.nom || m.nom,
    facturation: fact,
    date_debut: ph.date_debut || '',
    date_fin: ph.date_fin || null,
    // Rattache la phase à la ligne vendue d'origine (par id, pas par position dans un tableau) :
    // permet de retrouver ses dates réelles pour le C.A par année d'un contact.
    affaire_ligne_id: ph.ligne_id || null,
    jira_project_key: jiraKey,
    tjm: parseFloat(ph.tjm) || 0,
    jours_total: parseFloat(ph.jours_total) || 0,
    montant_global: parseFloat(ph.montant_global) || 0,
    nb_devs: parseFloat(ph.nb_devs) || 1,
    duree_mois: parseFloat(ph.duree_mois) || 0,
    correctif_qte: parseFloat(ph.correctif_qte) || 0,
    correctif_unite: ph.correctif_unite || 'heures_mois',
    evolutif_qte: parseFloat(ph.evolutif_qte) || 0,
    evolutif_unite: ph.evolutif_unite || 'jours_an',
  });
}

export function setPhaseEndDate(newEnd, phase) {
  return supabase.from('phases').update({ date_fin: newEnd }).eq('id', phase.id);
}

export function insertDefaultPhase(newId, phId) {
  return supabase.from('phases').insert({
    id: phId,
    client_id: newId,
    nom: 'Phase 1',
    facturation: 'forfait_brique',
    date_debut: '',
    date_fin: null,
  });
}

export function updatePhase(dbPh, modalData) {
  return supabase.from('phases').update(dbPh).eq('id', modalData.phaseId);
}

export function insertPhase(dbPh, modalData, newPhId) {
  return supabase.from('phases').insert({ id: newPhId, client_id: modalData.clientId, ...dbPh });
}

export function deletePhase(phase) {
  return supabase.from('phases').delete().eq('id', phase.id);
}

export function upsertPhases(c, ph) {
  return supabase.from('phases').upsert({
    id: ph.id,
    client_id: c.id,
    nom: ph.nom,
    facturation: ph.facturation || 'forfait_brique',
    date_debut: ph.dateDebut || '',
    date_fin: ph.dateFin || null,
    jira_project_key: ph.jira_project_key || '',
    tjm: ph.tjm || 0,
    jours_total: ph.joursTotal || 0,
    montant_global: ph.montantGlobal || 0,
    nb_devs: ph.nbDevs || 1,
    duree_mois: ph.dureeMois || 0,
    correctif_qte: ph.correctifQte || 0,
    correctif_unite: ph.correctifUnite || 'heures_mois',
    evolutif_qte: ph.evolutifQte || 0,
    evolutif_unite: ph.evolutifUnite || 'jours_an',
    date_fin_contrat: ph.dateFinContrat || '',
    echeance: ph.echeance || '',
  });
}

export function updatePhaseById(phaseId, patch) {
  return supabase.from('phases').update(patch).eq('id', phaseId);
}
